/**
 * @file wrapper-text-field.component.tsx
 * @description Form-control обертка для работы с WrapperTextField feature компонентом с поддержкой react-hook-form
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-09
 * @dependencies ['react', 'react-hook-form', '@components/ui/custom/inputs/wrapper-text-field']
 * @related-files ['@components/ui/custom/inputs/wrapper-text-field/wrapper-text-field.component.tsx']
 */

import { WrapperTextField as UIWrapperTextField } from '@components/ui/custom/inputs/wrapper-text-field';
import { Controller, Control, FieldValues, Path } from 'react-hook-form';
import { ComponentProps } from 'react';

/**
 * Props для компонента WrapperTextField с интеграцией react-hook-form
 */
interface IWrapperTextFieldProps<TFieldValues extends FieldValues = FieldValues> 
    extends Omit<ComponentProps<typeof UIWrapperTextField>, 'value' | 'onChange'> {
    /** Control объект из react-hook-form для управления формой */
    control: Control<TFieldValues>;
    /** Имя поля в форме (путь к значению) */
    name: Path<TFieldValues>;
    /** Плейсхолдер для поля ввода */
    placeholder?: string;
    /** Заблокировано ли поле */
    disabled?: boolean;
    /** CSS класс для стилизации */
    className?: string;
    /** Лейбл поля */
    label?: string;
}

export const WrapperTextField = <TFieldValues extends FieldValues = FieldValues>({ 
    control, 
    name, 
    ...props 
}: IWrapperTextFieldProps<TFieldValues>) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => <UIWrapperTextField onChange={field.onChange} value={field.value} {...props} />}
        />
    );
};
